export default defineNuxtPlugin(function (nuxtApp) {
  // Lock the AB Tasty tag before execution
  window.lockABTastyTag = true;
});